import { render, staticRenderFns } from "./ProfileGroupsTopNav.vue?vue&type=template&id=c87abe00"
import script from "./ProfileGroupsTopNav.vue?vue&type=script&lang=js"
export * from "./ProfileGroupsTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports